export default "__VITE_ASSET__DTT2hQHE__"